import { gql } from '@apollo/client';

const TASK_LIST_SECTION_TEMPLATE_UPDATE = gql`
  mutation taskListSectionTemplateUpdate(
    $input: TaskListSectionTemplateUpdateInput!
  ) {
    taskListSectionTemplateUpdate(input: $input) {
      taskListSectionTemplate {
        id
        title
        position
      }
    }
  }
`;

export default TASK_LIST_SECTION_TEMPLATE_UPDATE;
